import { TempPassword } from '../../src/components'
import Footer from '../../src/components/Footer'
import Header from '../../src/components/Header'

export default function Index() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <TempPassword />
      </div>
      <Footer />
    </>
  )
}
